import script from "./FileUploadModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileUploadModal.vue?vue&type=script&setup=true&lang=ts"

import "./FileUploadModal.vue?vue&type=style&index=0&id=015fc310&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-015fc310"]])

export default __exports__